import React from 'react';
import { Typography, Box, List, ListItem, ListItemText } from '@mui/material';

function Terms() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5">
        Wagl Terms of Service
      </Typography>

      <Typography variant="body1" mb={2} mt={2}>
        Welcome to Wagl!
      </Typography>

      <Typography variant="h6" mb={2}>
        1. Acceptance of Terms
      </Typography>
      <Typography variant="body1" mb={2}>
        By accessing or using Wagl ("the Site") you agree to be bound by these Terms of Service ("Terms"). If you do not agree with any of these Terms, please do not use the Site.
      </Typography>

      <Typography variant="h6" mb={2}>
        2. Your Use of Wagl
      </Typography>
      <Typography variant="body1">
        To keep the platform fun and safe for everyone, you agree not to:
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="- Share any content that is illegal, abusive, defamatory, or otherwise harmful." />
        </ListItem>
        <ListItem>
          <ListItemText primary="- Impersonate others or misrepresent yourself in any way." />
        </ListItem>
        <ListItem>
          <ListItemText primary="- Disrupt or interfere with the security or integrity of the Site." />
        </ListItem>
      </List>

      <Typography variant="h6" mb={2}>
        3. Your Content
      </Typography>
      <Typography variant="body1" mb={2}>
        When you share your art on Wagl, you retain ownership of your work. However, by posting, you grant Wagl a non-exclusive, royalty-free license to display, distribute, and promote your content as part of the Site’s normal operations. We will not sell or commercialize your work without your permission.
      </Typography>

      <Typography variant="h6" mb={2}>
        4. Profile and Account Security
      </Typography>
      <Typography variant="body1" mb={2}>
        You are responsible for safeguarding your Wagl profile. Keep your login information secure and notify us immediately if you suspect unauthorized use of your account.
      </Typography>

      <Typography variant="h6" mb={2}>
        5. Termination
      </Typography>
      <Typography variant="body1" mb={2}>
        We reserve the right to suspend or terminate any account that violates these Terms or for any reason, at our discretion.
      </Typography>

      <Typography variant="h6" mb={2}>
        6. Changes to Terms
      </Typography>
      <Typography variant="body1" mb={2}>
        We may update these Terms from time to time. If we do, we'll notify you of any changes. Continued use of the Site after changes means you accept the new Terms.
      </Typography>

      <Typography variant="h6" mb={2}>
        7. Liability Disclaimer
      </Typography>
      <Typography variant="body1" mb={2}>
        Wagl is provided "as is," and we make no warranties or guarantees about the availability or quality of the service. We are not liable for any content shared on the Site, user interactions, or disruptions in service.
      </Typography>

      <Typography variant="h6" mb={2}>
        8. Contact Information
      </Typography>
      <Typography variant="body1" mb={2}>
        For any questions or concerns, you can contact us at:
      </Typography>
      <Typography  ypography variant="body1" mb={2}>
        TODO: Add contact us
      </Typography>

      <Typography variant="body1" mb={2}>
        By using Wagl, you're agreeing to all the above.
      </Typography>
    </Box>
  );
}

export default Terms;
